import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { IoMdClose } from "react-icons/io";
import Classes from "../asset/styles/AdminEditCMSModal.module.css";
import { isEmpty } from "../lib/isEmpty";

import { updateCMSList } from "../actions/adminAction";
import toast from "react-hot-toast";
import { editLandingHeaderContent } from "../actions/cmsActions";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';


const AdminEditCMSModal = ({ show, handleClose, record, getcms }) => {
  const [formvalue, setFormvalue] = useState(record);
  const [content, setcontent] = useState(record?.content);


  const handleChange = (e) => {
    try {
      const { name, value } = e.target;
      let Formvalue = { ...formvalue, [name]: value };
      setFormvalue(Formvalue);
    } catch (err) {
      console.log(err, "handleChange");
    }
  };

  const handleChange1 = (value) => {
    try {
      setcontent(value)
    } catch (err) {
      console.log(err, "handleChange");
    }
  };
  const handleSubmit = async () => {
    try {
      let data = {
        identifier: formvalue.identifier,
        title: formvalue.title,
        content: content,
        _id: formvalue._id,
      };
      console.log(data, "handleSubmit");
      // let { status, message, result } = await updateCMSList(data);
      // if (status == true) {
      //   toast.success("Updated Successfully");
      //   getcms();
      //   onhandleClose();
      // } else {
      //   toast.error(message);
      // }
      let result = await editLandingHeaderContent(data);
      if (result.statusCode == 200 && result.status == true) {
        getcms();
        onhandleClose();
        toast.success(result.message);
      } else {
        toast.error(result.message);
      }
    } catch (err) {
      console.log(err, "handleSubmit__err");
    }
  };

  useEffect(() => {
    console.log(record, "record");
    if (!isEmpty(record)) {
      setFormvalue(record);
      setcontent(record?.content)
    }
  }, [record]);

  const onhandleClose = (e) => {
    try {
      setFormvalue();
      handleClose();
    } catch (err) {
      console.log(err, "handleChange");
    }
  };

  return (
    <>
      <Modal
        size="md"
        centered
        show={show}
        onHide={(e) => onhandleClose(e)}
        backdrop="static"
        keyboard={false}
        className={`cmnModal`}>
        <Modal.Body>
          <div className={`${Classes.modalHeader} text-end`}>
            <button
              className={`${Classes.modalCloser}`}
              onClick={() => {
                onhandleClose();
              }}>
              <IoMdClose />
            </button>
          </div>
          <h5
            className={`${Classes.modalTitle} m-0 text-center roboto mt-3 text-uppercase`}>
            Edit CMS Settings
          </h5>

          <div className={`${Classes.singleInpHolder} mt-3`}>
            <label
              for="identifier"
              className={`${Classes.inputLabel} orbitron`}>
              Identifier
            </label>
            <br />
            <input
              type="text"
              id="identifier"
              name="identifier"
              value={formvalue?.identifier}
              onChange={handleChange}
              className={`${Classes.inputBox} inter_font mt-3 w-100 p-2`}
              placeholder="Enter Identifier name"
              autoComplete="off"
              readOnly
            />
          </div>

          <div className={`${Classes.singleInpHolder} mt-3`}>
            <label for="title" className={`${Classes.inputLabel} orbitron`}>
              Title
            </label>
            <br />
            <input
              type="text"
              id="title"
              name="title"
              value={formvalue?.title}
              onChange={handleChange}
              className={`${Classes.inputBox} inter_font mt-3 w-100 p-2`}
              placeholder="Enter the Tittle"
              autoComplete="off"
            />
          </div>

          {/* <div className={`${Classes.singleInpHolder} mt-3`}>
            <label for="content" className={`${Classes.inputLabel} orbitron`}>
              Content
            </label>
            <br />
            <textarea
              className={`${Classes.textArea} w-100 mt-2 p-2 inter_font`}
              id="content"
              name="content"
              value={formvalue?.content}
              onChange={handleChange}
              placeholder="Enter the Content"

              rows={3}
              cols={50}
            />
          </div> */}
          <div>
            <label for="content" className={`${Classes.inputLabel} orbitron`}>
              Content
            </label>
            <ReactQuill
              onChange={handleChange1}
              id="content"
              theme="snow"
              value={content}
              type="text"
              className="reactQuillContainer"

            />
          </div>


          <div className={`text-center w-100 mt-4`}>
            <button
              className={`${Classes.whiteBtn} poppins`}
              onClick={(e) => handleSubmit(e)}>
              Save
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AdminEditCMSModal;
